import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Nav } from "./components/Nav";
import { Footer } from "./components/Footer";
import { Toasts } from "./components/Toasts";
import { Home } from "./pages/Home";
import { Trade } from "./pages/Trade";
import { Earn } from "./pages/Earn";
import { Portfolio } from "./pages/Portfolio";
import { Rewards } from "./pages/Rewards";
import { Docs } from "./pages/Docs";
import { NotFound } from "./pages/NotFound";

function ScrollTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) document.getElementById(hash.slice(1))?.scrollIntoView();
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

export function App() {
  return (
    <div className="shell">
      <div className="grid-bg" aria-hidden="true" />
      <ScrollTop />
      <Nav />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/trade" element={<Trade />} />
          <Route path="/earn" element={<Earn />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/rewards" element={<Rewards />} />
          <Route path="/docs" element={<Docs />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <Toasts />
    </div>
  );
}
